import Splide from "@splidejs/splide";

document.addEventListener("DOMContentLoaded", function () {
	const sliders = document.querySelectorAll("[data-destinations-slider]");

	if (!sliders.length) return;

	sliders.forEach(function (sliderEl) {
		if (sliderEl.classList.contains("is-initialized")) return;
		sliderEl.classList.add("is-initialized");

		const splide = new Splide(sliderEl, {
			type: "loop",
			perPage: 1,
			perMove: 1,
			gap: "1.6rem",
			padding: { right: "4.8rem" },
			arrows: false,
			pagination: false,
			mediaQuery: "min",
			breakpoints: {
				768: {
					perPage: 2,
					gap: "1.6rem",
					padding: { right: "4.8rem" },
				},
				1200: {
					perPage: 3,
					gap: "2.4rem",
					padding: { right: "4.8rem" },
				},
				1920: {
					perPage: 3,
					gap: "3.2rem",
					padding: { right: 0 },
				},
			},
		});

		splide.mount();

		// Wire custom arrows (both header and mobile)
		const container = sliderEl.closest(".destinations-block--slider");
		if (!container) return;

		container
			.querySelectorAll(".destinations-block__arrow.--prev")
			.forEach(function (btn) {
				btn.addEventListener("click", function () {
					splide.go("<");
				});
			});

		container
			.querySelectorAll(".destinations-block__arrow.--next")
			.forEach(function (btn) {
				btn.addEventListener("click", function () {
					splide.go(">");
				});
			});
	});
});
